import React, { useState, useCallback, useEffect } from "react";
import { TextField } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { SerializedTextFilter } from "../../../store/tableFilters";
import styled from "styled-components";

type TextFilterInputProps = {
  value: SerializedTextFilter;
  onChange: (filter: SerializedTextFilter) => void;
  placeholder?: string;
};

export const TextFilterInput = ({
  value,
  onChange,
  placeholder,
}: TextFilterInputProps) => {
  const { t } = useTranslation();
  const [localValue, setLocalValue] = useState(value.value);

  useEffect(() => {
    setLocalValue(value.value);
  }, [value.value]);

  const handleChange = useCallback(
    (
      event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
      newValue?: string,
    ) => {
      setLocalValue(newValue || "");
    },
    [],
  );

  const handleBlur = useCallback(() => {
    onChange({
      type: "text",
      value: localValue,
    });
  }, [localValue, onChange]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      if (event.key === "Enter") {
        onChange({
          type: "text",
          value: localValue,
        });
      }
    },
    [localValue, onChange],
  );

  return (
    <Container>
      <TextField
        value={localValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        placeholder={placeholder || t("ram.table.filter.enterText")}
        styles={{
          root: { width: "100%" },
          fieldGroup: { borderRadius: 4 },
        }}
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

export default TextFilterInput;
